<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && notaFiscal" class="text--primary">
      <v-row>
        <v-col cols="12" sm="7" class="font-weight-bold title">
          <px-nota-fiscal-fornecedor cnpj-class="body-2"
                                     :truncate="100"
                                     :nota-fiscal="notaFiscal"/>
        </v-col>
        <v-col cols="12" sm="5" class="text-right">
          <px-nota-fiscal-danfe-btn :nota-fiscal="notaFiscal"/>
          <px-nota-fiscal-xml-btn class="ml-2" :nota-fiscal="notaFiscal"/>
          <px-cadastro-nota-fiscal-vinculo-compra-dialog
            :nota-fiscal="notaFiscal"
            @change="onChangeNotaVinculo">
            <template v-slot:activator="{ on }">
              <v-btn class="normal-btn-text elevation-0 rounded-tag-x-small ml-3"
                     color="primary"
                     small
                     v-on="on">
                Vincular OC
              </v-btn>
            </template>
          </px-cadastro-nota-fiscal-vinculo-compra-dialog>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <div class="caption font-weight-bold">
            Chave de acesso
          </div>
          <div>
            {{ notaFiscal.chaveAcesso }}
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div class="caption font-weight-bold">
            Data emissão
          </div>
          {{ notaFiscal.dataEmissao | date(true) }}
        </v-col>
        <v-col cols="12" sm="3">
          <div class="caption font-weight-bold">
            Número / Série
          </div>
          {{ notaFiscal.numero }} / {{ notaFiscal.serie }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <div class="caption font-weight-bold">
            Natureza da operação
          </div>
          {{ notaFiscal.naturezaOperacao }}
        </v-col>
        <v-col cols="12" sm="6">
          <div class="caption font-weight-bold">
            Modalidade de transporte
          </div>
          <px-nota-fiscal-modo-transporte :modo-transporte="notaFiscal.modalidadeFrete"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" :sm="notaFiscal.nomeTransportadora ? '6' : '12'">
          <div class="caption font-weight-bold">
            Destinatário
          </div>
          <div>
            {{ notaFiscal.comprador.pessoa.nome }}
            <div>
              {{ notaFiscal.comprador.pessoa.cnpj | cnpj }}
            </div>
            <div>
              {{ notaFiscal.enderecoDestinatario | enderecoNota }}
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6" v-if="notaFiscal.nomeTransportadora">
          <div class="caption font-weight-bold">
            Transportadora
          </div>
          <div>
            {{ notaFiscal.nomeTransportadora }}
            <div>
              {{ notaFiscal.cnpjTransportadora | cnpj }}
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" :sm="hasFormasPagamentos ? '6' : '12'">
          <div class="caption font-weight-bold">
            Pagamentos
          </div>
          <div v-for="(pagamento, index) in notaFiscal.meiosPagamentos" :key="index">
            <px-nota-fiscal-meio-pagamento :meio-pagamento="pagamento.meioPagamento"/>
            - {{ pagamento.valor | currency }}
          </div>
        </v-col>
        <v-col cols="12" sm="6" v-if="hasFormasPagamentos">
          <div class="caption font-weight-bold">
            Duplicatas
          </div>
          <div v-for="(duplicata, index) in notaFiscal.formasPagamentos" :key="index">
            {{ duplicata.numeroParcela }} - {{ duplicata.dataVencimento | date }} -
            {{ duplicata.valor | currency }}
          </div>
        </v-col>
      </v-row>
      <template v-if="notaFiscal.notaFiscalCompraLinks && notaFiscal.notaFiscalCompraLinks.length">
        <v-row dense class="subtitle-1 font-weight-bold mt-3">
          <v-col cols="12">
            Ordens de compra
            <px-cadastro-nota-fiscal-vinculo-compra-dialog
              :nota-fiscal="notaFiscal"
              @change="onChangeNotaVinculo">
              <template v-slot:activator="{ on }">
                <v-btn class="normal-btn-text elevation-0 rounded-tag-x-small ml-3"
                       color="primary"
                       x-small
                       v-on="on">
                  Vincular OC
                </v-btn>
              </template>
            </px-cadastro-nota-fiscal-vinculo-compra-dialog>
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col cols="12">
            <px-nota-fiscal-vinculos :nota-fiscal="notaFiscal"/>
          </v-col>
        </v-row>
      </template>
      <v-row dense class="subtitle-1 font-weight-bold mt-3">
        <v-col cols="12" sm="4">
          Impostos
        </v-col>
        <v-col cols="12" sm="4">
        </v-col>
        <v-col cols="12" sm="4">
          Totais
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="4">
          <v-row dense>
            <v-col cols="6">
              ICMS
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.valorIcms | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              IPI
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.valorIpi | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              PIS
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.valorPis | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              Cofins
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.valorCofins | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              ST
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.valorSt | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              Difal Dest.
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.valorDifalDest || 0 | currency }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="4">
        </v-col>
        <v-col cols="12" sm="4">
          <v-row dense>
            <v-col cols="6">
              Produtos:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.totalProdutos | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              Total frete:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.totalFrete | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              Seguro:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.totalSeguro | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              Outros:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.totalOutros | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              Desconto:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.totalDesconto | currency }}
            </v-col>
          </v-row>
          <v-row dense class="font-weight-bold text--primary--color">
            <v-col cols="6">
              TOTAL:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.totalNotaFiscal | currency }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row dense class="subtitle-1 font-weight-bold">
        <v-col cols="12" sm="4">
          Produtos
        </v-col>
      </v-row>
      <px-nota-fiscal-item-produtos class="mt-3"
                                    :nota-fiscal="notaFiscal"/>
      <template v-if="notaFiscal.infoAdicionalCpl || notaFiscal.infoAdicionalFisco">
        <v-row dense class="subtitle-1 font-weight-bold mt-3">
          <v-col cols="12" sm="4">
            Dados adicionais
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            {{ notaFiscal.infoAdicionalCpl }}
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            Inf. fisco: {{ notaFiscal.infoAdicionalFisco }}
          </v-col>
        </v-row>
      </template>
    </div>
  </div>
</template>

<script>
import NotasFiscaisService from '@/modules/notas-fiscais/notas-fiscais-service';
import NotaFiscalFornecedor from '@/modules/notas-fiscais/NotaFiscalFornecedor.vue';
import NotaFiscalDanfeBtn from '@/modules/notas-fiscais/NotaFiscalDanfeBtn.vue';
import NotaFiscalMeioPagamento from '@/modules/notas-fiscais/NotaFiscalMeioPagamento.vue';
import NotaFiscalItemProdutos from '@/modules/notas-fiscais/NotaFiscalItemProdutos.vue';
import NotaFiscalVinculos from '@/modules/notas-fiscais/NotaFiscalVinculos.vue';
import CadastroNotaFiscalVinculoCompraDialog
  from '@/modules/notas-fiscais/vinculo/CadastroNotaFiscalVinculoCompraDialog.vue';
import NotaFiscalXmlBtn from '@/modules/notas-fiscais/NotaFiscalXmlBtn.vue';
import NotaFiscalModoTransporte from '@/modules/notas-fiscais/NotaFiscalModoTransporte.vue';

export default {
  props: {
    notaFiscalId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      notaFiscal: null,
      loading: false,
    };
  },
  computed: {
    hasFormasPagamentos() {
      return this.notaFiscal && this.notaFiscal.formasPagamentos
        && this.notaFiscal.formasPagamentos.length > 0;
    },
  },
  methods: {
    getNotaFiscal() {
      this.loading = true;
      NotasFiscaisService.getNotaFiscal(this.notaFiscalId)
        .then((response) => {
          this.notaFiscal = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onChangeNotaVinculo() {
      this.getNotaFiscal();
    },
  },
  created() {
    this.getNotaFiscal();
  },
  components: {
    pxNotaFiscalFornecedor: NotaFiscalFornecedor,
    pxNotaFiscalDanfeBtn: NotaFiscalDanfeBtn,
    pxNotaFiscalMeioPagamento: NotaFiscalMeioPagamento,
    pxNotaFiscalItemProdutos: NotaFiscalItemProdutos,
    pxNotaFiscalVinculos: NotaFiscalVinculos,
    pxCadastroNotaFiscalVinculoCompraDialog: CadastroNotaFiscalVinculoCompraDialog,
    pxNotaFiscalXmlBtn: NotaFiscalXmlBtn,
    pxNotaFiscalModoTransporte: NotaFiscalModoTransporte,
  },
};
</script>
